import {DateTime} from 'luxon';
import {showError} from 'perform-base/js/flashes';

export default function () {
  var addRow = function() {
    var rows = $('.invoice-rows');
    var prototype = $('#prototype').html();
    var index = rows.find('.invoice-row').length;
    var newForm = prototype.replace(/__name__/g, index);

    rows.append(newForm);
    setCurrency(detectCurrency());
  };


  var reorderRows = function() {
    var rows = $('.invoice-rows');
    rows.find('.invoice-row').each(function(index) {
      $(this).find('.sort-order').val(index);
      var $rateInfoButton = $(this).find('.action-links .toggle-rate-info');
      if ($(this).find('.rateId').val()) {
        $rateInfoButton.show();
      } else {
        $rateInfoButton.hide();
      }
      var $subscriptionEventInfoButton = $(this).find('.action-links .toggle-subscription-event-info');
      if ($(this).find('.subscriptionEventId').val()) {
        $subscriptionEventInfoButton.show();
      } else {
        $subscriptionEventInfoButton.hide();
      }
    });
  };

  $('.add-row').click(function(e) {
    e.preventDefault();
    addRow();
    reorderRows();
  });

  $('.add-project-rows').click(function(e) {
    e.preventDefault();
    var projectId = $('#invoice_projectForRate').val();
    var start = $('#invoice_rateStart').val();
    var end = $('#invoice_rateEnd').val();
    $.ajax({
      method: 'GET',
      url: `/invoices/rated-rows-for-project/${projectId}?start=${start}&end=${end}`
    }).then((response) => {
      response.forEach((row) => {
        addRow();
        var lastRow = $('.invoice-rows .invoice-row').last();
        lastRow.find('.description').val(row.description);
        lastRow.find('.quantity').val(row.quantity);
        lastRow.find('.unitPrice').val(row.unitPrice.amount / 100);
        lastRow.find('.rateId').val(row.rateId);
        lastRow.find('.rateStart').val(row.rateStart);
        lastRow.find('.rateEnd').val(row.rateEnd);
      });
      reorderRows();
      setCurrency(detectCurrency());
    }).catch((error) => {
      showError(error.responseJSON.error);
    });
  });

  $('.add-subscription-row').click(function(e) {
    e.preventDefault();
    var eventId = $('#invoice_subscriptionEvent').val();
    $.ajax({
      method: 'GET',
      url: `/invoices/row-for-subscription-event/${eventId}`
    }).then((response) => {
      addRow();
      var lastRow = $('.invoice-rows .invoice-row').last();
      lastRow.find('.description').val(response.description);
      lastRow.find('.quantity').val(response.quantity);
      lastRow.find('.unitPrice').val(response.unitPrice.amount / 100);
      lastRow.find('.subscriptionEventId').val(response.subscriptionEventId);
      reorderRows();
      setCurrency(detectCurrency());
    }).catch((error) => {
      showError(error.responseJSON.error);
    });
  });

  $('.set-to-last-billing-period').click(function(e) {
    e.preventDefault();
    var invoiceDate = DateTime.fromISO($('#invoice_invoiceDate').val());
    $('#invoice_rateStart').val(
      invoiceDate.startOf('month').minus({month: 1}).toISODate()
    );
    $('#invoice_rateEnd').val(
      invoiceDate.startOf('month').toISODate()
    );
  });

  $(document).on('click', '.invoice-row .remove', function(e) {
    e.preventDefault();
    $(this).parent().parent().remove();
    reorderRows();
  });

  $(document).on('click', '.invoice-row .move-up', function(e) {
    e.preventDefault();
    var row = $(this).parent().parent();
    var target = row.prev();
    row.insertBefore(target);
    reorderRows();
  });

  $(document).on('click', '.invoice-row .move-down', function(e) {
    e.preventDefault();
    var row = $(this).parent().parent();
    var target = row.next();
    row.insertAfter(target);
    reorderRows();
  });

  $(document).on('click', '.invoice-row .toggle-rate-info', function(e) {
    var $row = $(this).parents('.invoice-row');
    $row.find('.rate-info')
      .toggle()
      .find('.rate-id-display')
      .html($row.find('.rateId').val())
  });

  $(document).on('click', '.invoice-row .toggle-subscription-event-info', function(e) {
    var $row = $(this).parents('.invoice-row');
    $row.find('.subscription-event-info')
      .toggle()
      .find('.subscription-event-id-display')
      .html($row.find('.subscriptionEventId').val())
  });

  function setCurrency(code) {
    $('.invoice-rows').find('.currency').val(code);
    $('.invoice-rows').find('.currency-icon')
      .removeClass(`fa-gbp fa-usd`)
      .addClass(`fa-${code.toLowerCase()}`);
  }

  function detectCurrency() {
    var currency = $('#invoice_currency input:checked').val();
    if (currency) {
      return currency;
    }

    if ($('.invoice-row').length === 0) {
      return 'USD';
    }

    return $('.invoice-row').first().find('.currency').val();
  }

  $('#invoice_currency input').change(function() {
    setCurrency(detectCurrency());
  });

  $('#invoice_projectForRate').change(function() {
    $('.edit-work-types').attr('href', `/projects/work-types/${$(this).val()}`);
  });
  $('#invoice_projectForRate').change();

  reorderRows();
  var initialCurrency = detectCurrency();
  setCurrency(initialCurrency);
  var code = $(`#invoice_currency input[value=${initialCurrency}]`).prop('checked', true);
};



// WEBPACK FOOTER //
// ./assets/js/create-invoice.js